var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tabs',{staticClass:"content",attrs:{"tabsConfig":_vm.tabsConfig},on:{"tabClick":_vm.tabClick}},[_c(_vm.currentComponent,{tag:"component",attrs:{"pageType":_vm.pageType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }